<div class="smiley-container">
    <div
            *ngFor="let rating of ratings"
            class="smiley"
            [class.selected]="similarNomination.feedback === rating.value"
            (click)="selectRating(rating.value)">
        <span>{{ rating.emoji }}</span>
    </div>
</div>